module.exports = __webpack_public_path__ + "img/Platine_0001_2.3b0d5bd1.png";